module.exports = __webpack_public_path__ + "static/img/wm-logo.9918694.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wm-logo.png
// module id = HrTj
// module chunks = 0